import * as yup from "yup";
import { validationConfirmNewPasswordL, validationNewPassword, validationNotEmpty, } from "./defaultValidations";

export default yup.object({
    password: validationNewPassword("Password"),
    confirmPassword: validationConfirmNewPasswordL("Confirm Password"),
});